import { Invoice } from "../../entity/Invoice";
import { InvoiceDto } from "../dto/Invoice.Dto";
import { toDate } from "../../utils/GlobalFunctions";

export class InvoiceMapper {
  static toInvoice(invoice: InvoiceDto[]): Invoice[] {
    return invoice.map((inv) => ({
      id: inv.id,
      storePackId: inv.storePackId,
      storeId: inv.storeId,
      amount: inv.amount,
      status: inv.status,
      createdAt: inv.createdAt ? toDate(inv.createdAt) : undefined,
      updatedAt: inv.updatedAt ? toDate(inv.updatedAt) : undefined,
    }));
  }
}
